import { POSITION_DEBUG } from "../lib/thought-positions";

/** Rectangles aligned with cockpit-wrap CSS (challenge alert, console, placement bands). */
export function PositionDebugRects() {
  const { challengeExclusion, consoleZone, placementBands } = POSITION_DEBUG;

  return (
    <div className="act-debug-layer act-debug-layer--cockpit" aria-hidden>
      {placementBands.map((band) => (
        <div
          key={band.label}
          className="act-debug-rect act-debug-rect--band"
          style={{
            left: `${band.left}%`,
            top: `${band.top}%`,
            width: `${band.width}%`,
            height: `${band.height}%`,
          }}
        >
          <span className="act-debug-rect__label">{band.label}</span>
        </div>
      ))}

      <div
        className="act-debug-rect act-debug-rect--exclusion"
        style={{
          left: `${challengeExclusion.left}%`,
          top: `${challengeExclusion.top}%`,
          width: `${challengeExclusion.width}%`,
          height: `${challengeExclusion.height}%`,
        }}
      >
        <span className="act-debug-rect__label">{challengeExclusion.label}</span>
      </div>

      <div
        className="act-debug-rect act-debug-rect--console"
        style={{
          left: `${consoleZone.left}%`,
          top: `${consoleZone.top}%`,
          width: `${consoleZone.width}%`,
          height: `${consoleZone.height}%`,
        }}
      >
        <span className="act-debug-rect__label">{consoleZone.label}</span>
      </div>
    </div>
  );
}

/** Overlay point markers for console-blocking thoughts. */
export function PositionDebugMarkers() {
  const { overlayZones, placementBands } = POSITION_DEBUG;

  return (
    <div className="act-debug-layer act-debug-layer--thoughts" aria-hidden>
      {overlayZones.map((zone, i) => (
        <div
          key={`overlay-${i}`}
          className="act-debug-marker act-debug-marker--overlay"
          style={{ left: `${zone.x}%`, top: `${zone.y}%` }}
          title={zone.label ?? `Overlay ${i + 1}`}
        >
          <span className="act-debug-marker__label">O{i + 1}</span>
        </div>
      ))}

      <div className="act-debug-legend">
        <p className="act-debug-legend__title">Positie-debug</p>
        <ul>
          <li>
            <span className="act-debug-swatch act-debug-swatch--band" />
            Plaatsingsbanden ({placementBands.length})
          </li>
          <li>
            <span className="act-debug-swatch act-debug-swatch--exclusion" />
            {POSITION_DEBUG.challengeExclusion.label}
          </li>
          <li>
            <span className="act-debug-swatch act-debug-swatch--console" />
            {POSITION_DEBUG.consoleZone.label}
          </li>
          <li>
            <span className="act-debug-swatch act-debug-swatch--overlay" />
            Overlay-knoppen (O1–O{overlayZones.length})
          </li>
        </ul>
      </div>
    </div>
  );
}
